import { FormattedMessage } from "react-intl";
import EmptyState from "../common/empty-state/EmptyState.tsx";

const Graphic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="351"
      height="277"
      viewBox="0 0 351 277"
      fill="none"
      aria-hidden={true}
      focusable={false}
    >
      <g clipPath="url(#favorites-empty-graphic)">
        <path
          stroke="#425B9F"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
          d="M122.561 1.5h40.58"
        />
        <path
          stroke="#8FA1D2"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
          d="M1.5 108.07v15.28M172.43 1.5h17.63M348.701 39.76h-18.81M340.339 19.16l-13.3 13.3M319.939 9.75v18.81"
        />
        <path
          stroke="#425B9F"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
          d="M30.74 163.07H8.66a7.16 7.16 0 0 1-7.16-7.16v-21.99"
        />
        <path
          fill="#F0F2F7"
          d="M220.219 10.64h-109.42a5.35 5.35 0 0 0-5.35 5.35v159.18a5.35 5.35 0 0 0 5.35 5.35h109.42a5.35 5.35 0 0 0 5.35-5.35V15.99a5.35 5.35 0 0 0-5.35-5.35Z"
        />
        <path
          fill="#D2D9ED"
          d="M201.059 28.27h-71.09a5.35 5.35 0 0 0-5.35 5.35v88.05a5.35 5.35 0 0 0 5.35 5.35h71.09a5.35 5.35 0 0 0 5.35-5.35V33.62a5.35 5.35 0 0 0-5.35-5.35ZM201.059 142.75h-71.09a5.35 5.35 0 0 0-5.35 5.35v1.73a5.35 5.35 0 0 0 5.35 5.35h71.09a5.35 5.35 0 0 0 5.35-5.35v-1.73a5.35 5.35 0 0 0-5.35-5.35Z"
        />
        <path
          fill="#F0F2F7"
          d="M89.44 37.42H14.5a3.66 3.66 0 0 0-3.66 3.66V150.1a3.66 3.66 0 0 0 3.66 3.66h74.94a3.66 3.66 0 0 0 3.66-3.66V41.08a3.66 3.66 0 0 0-3.66-3.66Z"
        />
        <path
          fill="#D0D7EB"
          d="M76.32 49.48H27.63a3.66 3.66 0 0 0-3.66 3.66v60.31a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66V53.14a3.66 3.66 0 0 0-3.66-3.66ZM76.32 127.89H27.63a3.66 3.66 0 0 0-3.66 3.66v1.19a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66v-1.19a3.66 3.66 0 0 0-3.66-3.66Z"
        />
        <path
          fill="#F0F2F7"
          d="M317.2 37.121h-74.94a3.66 3.66 0 0 0-3.66 3.66v109.02a3.66 3.66 0 0 0 3.66 3.66h74.94a3.66 3.66 0 0 0 3.66-3.66V40.781a3.66 3.66 0 0 0-3.66-3.66Z"
        />
        <path
          fill="#D0D7EB"
          d="M304.071 49.18h-48.69a3.66 3.66 0 0 0-3.66 3.66v60.31a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66V52.84a3.66 3.66 0 0 0-3.66-3.66ZM304.071 127.59h-48.69a3.66 3.66 0 0 0-3.66 3.66v1.19a3.66 3.66 0 0 0 3.66 3.66h48.69a3.66 3.66 0 0 0 3.66-3.66v-1.19a3.66 3.66 0 0 0-3.66-3.66Z"
        />
      </g>
      <path
        fill="#F0F2F7"
        d="M289.106 206.645H188.894c-2.703 0-4.894.789-4.894 1.763v52.537c0 .974 2.191 1.764 4.894 1.764h100.212c2.703 0 4.894-.79 4.894-1.764v-52.537c0-.974-2.191-1.763-4.894-1.763Z"
      />
      <path
        fill="#D0D7EB"
        d="M276.184 216.28h-77.368c-3.212 0-5.816 1.181-5.816 2.638v.857c0 1.457 2.604 2.637 5.816 2.637h77.368c3.212 0 5.816-1.18 5.816-2.637v-.857c0-1.457-2.604-2.638-5.816-2.638ZM250.949 232.048h-53.898c-2.237 0-4.051 1.181-4.051 2.637v.858c0 1.456 1.814 2.637 4.051 2.637h53.898c2.237 0 4.051-1.181 4.051-2.637v-.858c0-1.456-1.814-2.637-4.051-2.637ZM263.099 247.816h-65.198c-2.707 0-4.901 1.181-4.901 2.638v.857c0 1.457 2.194 2.637 4.901 2.637h65.198c2.707 0 4.901-1.18 4.901-2.637v-.857c0-1.457-2.194-2.638-4.901-2.638Z"
      />
      <path
        fill="#3BBAE3"
        d="M280.78 272.381c1.91.315 3.76-.788 4.12-2.47l1.3-6.062 6.23 11.081c.86 1.533 2.98 2.164 4.73 1.41 1.75-.753 2.47-2.61 1.61-4.143l-6.24-11.108 6.32 2.812c1.74.78 3.87.167 4.75-1.358.89-1.524.19-3.381-1.55-4.161l-21.98-18.115a4.002 4.002 0 0 0-3.16-.018c-1 .429-1.71 1.244-1.91 2.208l2.97 26.306c-.36 1.682.9 3.294 2.82 3.609l-.01.009Z"
      />
      <ellipse cx="190.5" cy="194.818" fill="#D2D9ED" rx="5.5" ry="4.818" />
      <ellipse cx="205.5" cy="194.818" fill="#D2D9ED" rx="5.5" ry="4.818" />
      <ellipse cx="220.5" cy="194.818" fill="#D2D9ED" rx="5.5" ry="4.818" />
      <defs>
        <clipPath id="favorites-empty-graphic">
          <path fill="#fff" d="M0 0h368.19v180.52H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default function FavoritesEmpty() {
  return (
    <EmptyState
      graphic={<Graphic />}
      title={<FormattedMessage defaultMessage="Save your favorites!" />}
      body={
        <FormattedMessage defaultMessage="Add items to your favorites by selecting the 3-dot icon on a card and choosing ‘Add to Favorites’" />
      }
    />
  );
}
